import PeopleSchemaSerializer from './base';

export default class Set extends PeopleSchemaSerializer {}
